import { render, staticRenderFns } from "./ProductPost.vue?vue&type=template&id=a5dc59d8&scoped=true"
import script from "./ProductPost.vue?vue&type=script&lang=js"
export * from "./ProductPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5dc59d8",
  null
  
)

export default component.exports